let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7jHZn")).then(() => parcelRequire('8KJda'));